<p [innerHtml]="'settings.notifications.product_level_info' | translate" class="text-muted"></p>
<p translate class="text-muted">settings.notifications.account_subtext</p>
<sk-notification-settings-form [productType]="ProductType.account"></sk-notification-settings-form>
